import React from 'react';
import { Route } from 'react-router-dom';

import GuestHomePage from '../pages/guest/GuestHomePage.jsx';
import RoomServicesPage from '../pages/guest/RoomServicesPage.jsx';
import ServiceRequestConfirmationPage from '../pages/guest/ServiceRequestConfirmationPage.jsx';
import RequestStatusPage from '../pages/guest/RequestStatusPage.jsx';
import ExploreSuggestionsPage from '../pages/guest/ExploreSuggestionsPage.jsx';
import TravelHelpPage from '../pages/guest/TravelHelpPage.jsx';
import ExpiredQRPage from '../pages/guest/ExpiredQRPage.jsx';
import GuestHotelServicesPage from '../pages/guest/GuestHotelServicePage.jsx';
import GuestSurveyPage from '../pages/guest/GuestSurveyPage.jsx';
import GuestFoodOrderPage from '../pages/guest/GuestFoodOrderPage.jsx';
import RoomQrEntryPage from '../pages/guest/RoomQrEntryPage.jsx';
import GuestBillingPage from '../pages/guest/GuestBillingPage.jsx';
import GuestProfilePage from '../pages/guest/GuestProfilePage.jsx';
import GuestLoyaltyPage from '../pages/guest/GuestLoyaltyPage.jsx';
import GuestMembershipPage from '../pages/guest/GuestMembershipPage.jsx';
import GuestCouponsPage from '../pages/guest/GuestCouponsPage.jsx';
import GuestCouponRedeemPage from '../pages/guest/GuestCouponRedeemPage.jsx';
import GuestRegisterPage from '../pages/guest/GuestRegisterPage.jsx';

const GuestRoutes = () => {
  return (
    <>
      <Route path="/guest/r/:roomPublicCode" element={<RoomQrEntryPage />} />
      <Route path="/guest/home" element={<GuestHomePage />} />
      <Route path="/guest/services" element={<RoomServicesPage />} />
      <Route path="/guest/confirmation" element={<ServiceRequestConfirmationPage />} />
      <Route path="/guest/status/:requestId" element={<RequestStatusPage />} />
      <Route path="/guest/suggestions" element={<ExploreSuggestionsPage />} />
      <Route path="/guest/travel-help" element={<TravelHelpPage />} />
      <Route path="/guest/expired" element={<ExpiredQRPage />} />
      <Route path="/guest/hotel-services" element={<GuestHotelServicesPage />} />
      <Route path="/guest/survey" element={<GuestSurveyPage />} />
      <Route path="/guest/feedback" element={<GuestSurveyPage />} />
      <Route path="/guest/food-order" element={<GuestFoodOrderPage />} />
      <Route path="/guest/billing" element={<GuestBillingPage />} />
      <Route path="/guest/profile" element={<GuestProfilePage />} />
      <Route path="/guest/loyalty" element={<GuestLoyaltyPage />} />
      <Route path="/guest/membership" element={<GuestMembershipPage />} />
      <Route path="/guest/coupons" element={<GuestCouponsPage />} />
      <Route path="/guest/coupons/redeem" element={<GuestCouponRedeemPage />} />
      <Route path="/guest/register" element={<GuestRegisterPage />} />
    </>
  );
};

export default GuestRoutes;
